import React from 'react';
import gql from 'graphql-tag';
import { get } from 'lodash';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { getUnits } from 'utils/unit';
import { unitSelector } from 'redux/preferences/selectors';

export const CASE_DEALER_RESPONSES_QUERY_NAME =
  'compositions_CaseDealerSelectionPanel_caseDealerResponses';

export const CASE_DEALER_RESPONSES_QUERY = gql`
  query ${CASE_DEALER_RESPONSES_QUERY_NAME} (
    $caseNumber: String!
    $distanceUnit: DistanceUnit,
  ) {
    case(caseNumber: $caseNumber) {
      id
      status
      dealerResponses {
        dealer {
          ... on Dealer {
            id
            name
            shipTo
            billTo
            storeNumber
            name
            phone
            displayAddress {
              city
              countryCode
              postalCode
              province
              streetAddress
            }
            timezone
            operatingStatus {
              ersOpen
              open
            }
            ers247
          }
          ... on CustomDealer {
            id
            name
            mileageRange {
              id
              max
              min
            }
          }
        }
        responses {
          id
          accepted
          contactPerson
          eta {
            id
          }
          note
          phoneNumber
          reason
          responseTime
          alternativeProductAvailable
          alternativePreferenceAvailable
        }
      }
      dealerTravelEstimateAtDispatch {
        distance(unit: $distanceUnit)
        time
      }
      servicingDealer {
        id
        dealer {
          ... on Dealer {
            id
          }
          ... on CustomDealer {
            id
            name
            mileageRange {
              id
            }
          }
        }
        accepted
        contactPerson
        eta {
          id
        }
        note
        phoneNumber
        reason
        responseTime
        alternativeProductAvailable
        alternativePreferenceAvailable
      }
    }
  }
`;

const withQuery = WrappedComponent => componentProps => (
  <Query
    query={CASE_DEALER_RESPONSES_QUERY}
    skip={!componentProps.caseNumber}
    variables={{
      caseNumber: componentProps.caseNumber,
      distanceUnit: getUnits(componentProps.unit).distanceUnitValue,
    }}
    fetchPolicy="cache-and-network"
  >
    {({ data }) => {
      /** @type {string} */
      const caseId = get(data, 'case.id');
      /** @type {DealerResponses} */
      const caseDealerResponses = get(data, 'case.dealerResponses', []);
      /** @type {ServicingDealer} */
      const servicingDealer = get(data, 'case.servicingDealer');

      const servicingDealerTravelEstimateAtDispatch = get(
        data,
        'case.dealerTravelEstimateAtDispatch',
      );

      return (
        <WrappedComponent
          {...componentProps}
          caseId={caseId}
          caseDealerResponses={caseDealerResponses}
          servicingDealer={servicingDealer}
          servicingDealerTravelEstimateAtDispatch={
            servicingDealerTravelEstimateAtDispatch
          }
        />
      );
    }}
  </Query>
);

const mapStateToProps = state => ({ unit: unitSelector(state) });

const withCaseDealerResponses = WrappedComponent =>
  compose(
    connect(mapStateToProps),
    withQuery,
  )(WrappedComponent);

export default withCaseDealerResponses;



// WEBPACK FOOTER //
// ./src/compositions/CaseDealerSelectionPanel/withCaseDealerResponses/index.js